export default "__VITE_ASSET__GXVKEn21__"